import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatGridListModule } from '@angular/material/grid-list';
import { HomePageComponent } from './home-page/home-page.component';
import { MatTableModule } from '@angular/material/table';
import { SearchDisplayComponent } from './search-display/search-display.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { HttpClientModule } from '@angular/common/http';
import { CartDisplayComponent, SaveDialog } from './cart-display/cart-display.component';
import { NgxPrintModule } from 'ngx-print';
import { DeleteDialog, OrderPageComponent } from './order-page/order-page.component';
import { MatListModule } from '@angular/material/list';
import { MatDialogModule } from '@angular/material/dialog';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { AddProductComponent } from './add-product/add-product.component';
import { EditProductComponent } from './edit-product/edit-product.component';
import { ProductListComponent, ReceiveDialog } from './product-list/product-list.component';
import { QuickBoardComponent } from './quick-board/quick-board.component';
import { NgxBarcodeModule } from 'ngx-barcode';
import { AddCustomerComponent } from './add-customer/add-customer.component';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { SummaryPageComponent } from './summary-page/summary-page.component';
import { ChartModule } from 'angular2-chartjs';
import { MatTabsModule } from '@angular/material/tabs';
import { MatCheckboxModule } from '@angular/material/checkbox';

const material = [
  MatInputModule,
  MatIconModule,
  MatGridListModule,
  MatButtonModule,
  MatTableModule,
  MatPaginatorModule,
  MatListModule,
  MatSortModule,
  MatDialogModule,
  DragDropModule,
  MatSelectModule,
  MatButtonToggleModule,
  MatAutocompleteModule,
  MatTabsModule,
  MatCheckboxModule
];
@NgModule({
  declarations: [
    AppComponent,
    HomePageComponent,
    SearchDisplayComponent,
    CartDisplayComponent,
    OrderPageComponent,
    SaveDialog,
    DeleteDialog,
    ReceiveDialog,
    AddProductComponent,
    EditProductComponent,
    ProductListComponent,
    QuickBoardComponent,
    AddCustomerComponent,
    SummaryPageComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgxPrintModule,
    NgxBarcodeModule,
    ChartModule,
    material
  ],
  providers: [MatFormFieldModule],
  exports: [
    material
  ],
  bootstrap: [AppComponent],
  entryComponents: [
    MatDialogModule
  ]
})
export class AppModule { }
